import { Page, Text, View, StyleSheet, Link } from "@react-pdf/renderer";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import { removeEmoji, formateISODateToDateTime, getFullName } from "@/utils";

const TitlePage = ({ title, createdDate, author, definition, navs, config }) => {
  const styles = StyleSheet.create({
    page: {
      backgroundColor: "white",
      color: "#303030",
      fontFamily: "Inter",
      fontSize: 9,
      padding: "30px 55px 118px",
    },

    h1: {
      fontSize: 18,
      fontWeight: 600,
      lineHeight: 1.4,
      marginBottom: 16,
    },

    h2: {
      fontSize: 9,
      lineHeight: 1.4,
      color: "#777",
      marginBottom: 8,
    },

    h3: {
      fontSize: 9,
      lineHeight: 1.4,
      color: "#bbb",
      marginBottom: 3,
    },

    information: {
      flexDirection: "column",
      gap: 10,
      backgroundColor: "#FCFCFC",
      borderRadius: 5,
      padding: 10,
      marginBottom: 16,
    },

    marks: {
      flexDirection: "column",
      gap: 3,
    },

    mark: {
      padding: "5px 10px",
      backgroundColor: "#F8FBFF",
      color: "#0066A6",
      textDecoration: "none",
      borderRadius: 5,
    },
  });

  return (
    <Page size="A4" dpi={72} style={styles.page}>
      <Header createdDate={createdDate} config={config} />

      <Text style={styles.h1}>{title}</Text>

      <Text style={styles.h2}>Информация</Text>
      <View style={styles.information}>
        <View>
          <Text style={styles.h3}>Паспорт объекта:</Text>
          <Text>{title}</Text>
        </View>
        <View>
          <Text style={styles.h3}>Тип объекта:</Text>
          <Text>{removeEmoji(definition)}</Text>
        </View>
        <View>
          <Text style={styles.h3}>Дата создания паспорта:</Text>
          <Text>{formateISODateToDateTime(createdDate)}</Text>
        </View>
        <View>
          <Text style={styles.h3}>Автор:</Text>
          <Text>
            {getFullName(author.lastname, author.firstname, author.patronymic)}
          </Text>
        </View>
      </View>

      <Text style={styles.h2}>Содержание</Text>
      <View style={styles.marks}>
        {navs.map((nav) => (
          <Link
            src={`#${nav.uuid}`}
            style={styles.mark}
            key={nav.uuid}
            wrap={false}
          >
            {nav.name}
          </Link>
        ))}
      </View>

      <Footer createdDate={createdDate} author={author} />
    </Page>
  );
};

export default TitlePage;
